(function () {
  'use strict'

  var VIEW_STORAGE_KEY = 'stich_hb_collection_view'
  var THEME_COL_STORAGE_KEY = 'gridColumnViews'
  var STRIP_ON_SORT = ['page', 'phcursor', 'cursor']

  function ready (fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn)
    } else {
      fn()
    }
  }

  function applySort (sortValue) {
    var url = new URL(window.location.href)
    var next = new URLSearchParams()

    url.searchParams.forEach(function (value, key) {
      if (key === 'sort_by') return
      if (STRIP_ON_SORT.indexOf(key) !== -1) return
      next.append(key, value)
    })

    if (sortValue) {
      next.set('sort_by', sortValue)
    }

    url.search = next.toString()
    window.location.assign(url.toString())
  }

  function getSavedView () {
    try {
      return window.localStorage.getItem(VIEW_STORAGE_KEY)
    } catch (e) {
      return null
    }
  }

  function saveView (view) {
    try {
      window.localStorage.setItem(VIEW_STORAGE_KEY, view)
    } catch (e) {
      /* ignore */
    }
  }

  function syncThemeCollectionState (view, gridColumns) {
    try {
      window.localStorage.setItem(
        THEME_COL_STORAGE_KEY,
        view === 'list' ? '1' : String(gridColumns)
      )
    } catch (e) {
      /* ignore */
    }

    if (window.MinimogTheme && MinimogTheme.Collection) {
      MinimogTheme.Collection.activeCol = view === 'list' ? 1 : Number(gridColumns)
    }
  }

  function setProductView (toolbar, view) {
    var gridColumns = toolbar.getAttribute('data-grid-columns') || '3'
    var section = toolbar.closest('[data-section-type="collection-template"]')
    var productGrid = section
      ? section.querySelector('[data-stich-hb-product-grid]')
      : document.querySelector('[data-stich-hb-product-grid]')

    toolbar.querySelectorAll('[data-stich-hb-view]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-stich-hb-view') === view
      btn.classList.toggle('is-active', isActive)
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false')
    })

    if (!productGrid) return

    productGrid.classList.remove(
      'stich-hb-view-list',
      'm-cols-1',
      'm-cols-2',
      'm-cols-3',
      'm-cols-4',
      'm-cols-5'
    )

    if (view === 'list') {
      productGrid.classList.add('stich-hb-view-list', 'm-cols-1')
    } else {
      productGrid.classList.add('m-cols-' + gridColumns)
    }

    if (section) {
      section.setAttribute('data-initial-column', view === 'list' ? '1' : gridColumns)
      section.classList.toggle('stich-hb-section-list', view === 'list')
    }

    syncThemeCollectionState(view, gridColumns)
    saveView(view)

    setupAllListViewActions()

    document.dispatchEvent(
      new CustomEvent('stich-hb:collection-view-changed', { detail: { view: view } })
    )
  }

  function getViewForToolbar (toolbar) {
    var initialView = toolbar.getAttribute('data-initial-view') || 'grid'
    var savedView = getSavedView()
    return savedView === 'grid' || savedView === 'list' ? savedView : initialView
  }

  function applyToolbarView (toolbar) {
    setProductView(toolbar, getViewForToolbar(toolbar))
  }

  function initToolbar (toolbar) {
    if (!toolbar || toolbar.getAttribute('data-stich-hb-toolbar-ready') === '1') return
    toolbar.setAttribute('data-stich-hb-toolbar-ready', '1')

    var sortSelect = toolbar.querySelector('[data-stich-hb-sort]')
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        applySort(sortSelect.value)
      })
    }

    toolbar.querySelectorAll('[data-stich-hb-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setProductView(toolbar, btn.getAttribute('data-stich-hb-view'))
      })
    })

    applyToolbarView(toolbar)
  }

  var CART_BTN_RE = /add to cart|add to bag|choose options|select options|request quote/i

  function isListViewActive () {
    return Boolean(document.querySelector('.stich-hb-view-list.m-cols-1'))
  }

  function hasCartButton (el) {
    if (!el) return false
    if (el.matches('form[action*="/cart/add"], .m-product-form, product-form')) return true
    var controls = el.querySelectorAll('button, [type="submit"], .m-button, a.m-button, [data-add-to-cart]')
    return Array.prototype.some.call(controls, function (btn) {
      if (btn.name === 'add') return true
      if (btn.hasAttribute('data-add-to-cart')) return true
      if (btn.closest('form[action*="/cart/add"], .m-product-form, product-form')) return true
      var label = ((btn.textContent || '') + ' ' + (btn.getAttribute('aria-label') || '')).trim()
      return CART_BTN_RE.test(label)
    })
  }

  function clearListViewActionMarkers (card) {
    card.querySelectorAll('[data-stich-list-primary-action], [data-stich-list-hidden-duplicate]').forEach(function (el) {
      el.removeAttribute('data-stich-list-primary-action')
      el.removeAttribute('data-stich-list-hidden-duplicate')
      el.style.removeProperty('display')
    })
  }

  function getTopLevelActionCandidates (root) {
    var selector = '.m-product-card__action, .m-product-card__action-main, .m-product-card__action-wrapper, form[action*="/cart/add"], .m-product-form, product-form'
    var all = Array.prototype.slice.call(root.querySelectorAll(selector))

    return all.filter(function (el) {
      if (!hasCartButton(el)) return false
      return !all.some(function (other) {
        return other !== el && other.contains(el)
      })
    })
  }

  function clearListViewLayoutMarkers (card) {
    card.querySelectorAll('[data-stich-list-title], [data-stich-list-price], [data-stich-list-description]').forEach(function (el) {
      el.removeAttribute('data-stich-list-title')
      el.removeAttribute('data-stich-list-price')
      el.removeAttribute('data-stich-list-description')
    })
  }

  function markListViewElements (card) {
    clearListViewLayoutMarkers(card)
    if (!isListViewActive()) return

    var content = card.querySelector('.m-product-card__content, .m-product-card__info')
    if (!content) return

    var title = content.querySelector(
      '.m-product-card__name, .m-product-card__title, a.m-product-card__name, .m-product-card__link'
    )
    if (title) title.setAttribute('data-stich-list-title', '1')

    var price = content.querySelector('.m-product-card__price, .m-price, .m-product-card__price-wrapper')
    if (price) price.setAttribute('data-stich-list-price', '1')

    var desc = content.querySelector(
      '.m-product-card__excerpt, .m-product-card__description, .m-product-card__short-description, .pcard-description, .m-product-card__content-bottom'
    )
    if (!desc) {
      var root = card.querySelector('.m-product-card__wrapper') || card
      desc = root.querySelector('.m-product-card__excerpt, .m-product-card__description, .m-product-card__short-description')
    }
    if (desc) desc.setAttribute('data-stich-list-description', '1')
  }

  function setupListViewPrimaryAction (card) {
    clearListViewActionMarkers(card)
    if (!isListViewActive()) return

    markListViewElements(card)

    var root = card.querySelector('.m-product-card__wrapper') || card.querySelector('.m-product-card') || card
    var candidates = getTopLevelActionCandidates(root)
    if (!candidates.length) return

    var primary = candidates.find(function (candidate) {
      return candidate.closest('.m-product-card__content, .m-product-card__info')
    })

    if (!primary) {
      candidates.forEach(function (candidate) {
        if (candidate.parentElement === root) primary = primary || candidate
      })
    }

    if (!primary) {
      primary = candidates.find(function (candidate) {
        return candidate.classList.contains('m-product-card__action-main') ||
          candidate.classList.contains('m-product-card__action')
      })
    }

    if (!primary) primary = candidates[0]
    primary.setAttribute('data-stich-list-primary-action', '1')

    candidates.forEach(function (candidate) {
      if (candidate === primary) return
      if (primary.contains(candidate) || candidate.contains(primary)) return
      candidate.setAttribute('data-stich-list-hidden-duplicate', '1')
    })
  }

  function setupAllListViewActions () {
    if (!isListViewActive()) {
      document.querySelectorAll('[data-stich-list-primary-action], [data-stich-list-hidden-duplicate], [data-stich-list-title], [data-stich-list-price], [data-stich-list-description]').forEach(function (el) {
        el.removeAttribute('data-stich-list-primary-action')
        el.removeAttribute('data-stich-list-hidden-duplicate')
        el.removeAttribute('data-stich-list-title')
        el.removeAttribute('data-stich-list-price')
        el.removeAttribute('data-stich-list-description')
        el.style.removeProperty('display')
      })
      return
    }

    document.querySelectorAll('.stich-hb-view-list .m-product-item, .stich-hb-view-list .m-product-card').forEach(setupListViewPrimaryAction)
  }

  function boot () {
    document.querySelectorAll('[data-stich-hb-toolbar]').forEach(initToolbar)
    setupAllListViewActions()
  }

  function reapplyViews () {
    document.querySelectorAll('[data-stich-hb-toolbar]').forEach(applyToolbarView)
    setupAllListViewActions()
  }

  ready(boot)
  window.addEventListener('load', reapplyViews)
  document.addEventListener('shopify:section:load', boot)
  document.addEventListener('collection:rerendered', reapplyViews)
  document.addEventListener('stich-hb:collection-view-changed', setupAllListViewActions)
})()
